function registerLogin() {
    const formElem = document.getElementById('login_form') as HTMLFormElement;
    const loginErrorMsgElem = document.getElementById('login_error') as HTMLParagraphElement;
    
    formElem.addEventListener('submit', async (e) => {
        e.preventDefault();
        const resp = await fetch('/session', {
            method: 'POST',
            body: new FormData(formElem)
        });

        if(resp.redirected) {
            window.location.replace(resp.url);
        } else if(resp.status === 401) {
            loginErrorMsgElem.textContent = 'Invalid username or password';
        } else {
            loginErrorMsgElem.textContent = 'Processing error';
        }
    });
}

if (document.readyState === 'complete') {
    registerLogin();
} else {
    document.addEventListener('DOMContentLoaded', registerLogin);
}